import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import Auth from '../../Components/Auth/Auth';
import logo from '../../Images/logo_white.png';
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LogoutIcon from '@mui/icons-material/Logout';
import CheckList from '../Check-in/CheckList';
import QueueCreate from '../Queue/QueueCreate';
import QueueList from '../Queue/QueueList';
import QueuePass from '../Queue/QueuePass';
import ServiceList from '../Service/ServiceList';
import CheckInHistory from '../History/CheckInHistory';
import ServiceHistory from '../History/ServiceHistory';
import QRCode from '../QR-Code/GenQR';

import gpsIcon from '../../Images/Icons/gps.png';
import userIcon from '../../Images/Icons/user.png';
import servIcon from '../../Images/Icons/dashboard.png';
import dateIcon from '../../Images/Icons/datetime.png';
import historyIcon from '../../Images/Icons/report.png';
import qrcodeIcon from '../../Images/Icons/qr-code.png';

const drawerWidth = 280;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function PersistentDrawerLeft() {
  // For History to Change Route
  const history = useHistory();

  // For get data from user login
  const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
  const username = tokenData.emp_info[0].emp_code;

  // For Drawer Menu
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // For Button Menu Username to Logout
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openBtn = Boolean(anchorEl);
  const userClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const userClose = () => {
    setAnchorEl(null);
  };

  // For use Location
  const { pathname } = useLocation();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} className='home_appbar'>
        <Toolbar>
          <Typography>
            <img src={logo} width='40' />
          </Typography>

          <Typography>
            <div className='home_toolbar_name'>CS_Management</div>
          </Typography>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuIcon className='home_toolbar_menu' style={{ fontSize: "1.3em" }} />
          </IconButton>

          <Typography
            sx={{ marginLeft: "auto" }}>
            <Button
              className='home_toolbar_userBtn'
              sx={{ color: "white" }}
              id="basic-button"
              aria-controls={openBtn ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openBtn ? 'true' : undefined}
              onClick={userClick}
            >
              {username}@laotel.com
              <KeyboardArrowDownIcon />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openBtn}
              onClose={userClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              elevation={0}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem
                className='home_toolbar_userBtnSub'
                onClick={userClose}
              >
                <PermIdentityIcon /> ຂໍ້ມູນສ່ວນຕົວ
              </MenuItem>

              <MenuItem
                className='home_toolbar_userBtnSub'
                onClick={userClose}
              >
                <ContentCopyIcon /> ຄູ່ມືການໃຊ້ງານ
              </MenuItem>

              <MenuItem
                className='home_toolbar_userBtnSub'
                onClick={() => {
                  Auth.logout(() => {
                    history.push("/");
                  });
                }}>
                <LogoutIcon /> ອອກຈາກລະບົບ
              </MenuItem>
            </Menu>
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <div className='home_drawer_tabmenu' style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon style={{ color: "#4A4343", fontSize: "1.3em" }} /> : <ChevronRightIcon />}
            </IconButton>
          </DrawerHeader>

          <Box sx={{
            flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#c4c4c4', borderRadius: '4px' },
          }}>

            <List>
              <ListItemButton
                className={
                  pathname === "/home"
                    ? "home_drawer_menu menu-active"
                    : "home_drawer_menu"
                }
                onClick={() => history.push("/home")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={gpsIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="Check-in ສູນບໍລິການ"
                />
              </ListItemButton>
            </List>

            <List>
              <ListItemButton
                className={
                  pathname === "/home/queue/create"
                    ? "home_drawer_menu menu-active"
                    : pathname === "/home/queue/list"
                      ? "home_drawer_menu menu-active"
                      : pathname === "/home/queue/pass"
                        ? "home_drawer_menu menu-active"
                        : "home_drawer_menu"
                }
                onClick={() => history.push("/home/queue/create")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={userIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="ຄິວລູກຄ້າ"
                />
              </ListItemButton>
            </List>

            <List>
              <ListItemButton
                className={
                  pathname === "/home/service"
                    ? "home_drawer_menu menu-active"
                    : "home_drawer_menu"
                }
                onClick={() => history.push("/home/service")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={servIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="ເປີດບິນບໍລິການ"
                />
              </ListItemButton>
            </List>

            <List>
              <ListItemButton
                className={
                  pathname === "/home/check_date"
                    ? "home_drawer_menu menu-active"
                    : "home_drawer_menu"
                }
                onClick={() => history.push("/home/check_date")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={dateIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="ປະຫວັດ Check-in"
                />
              </ListItemButton>
            </List>

            <List>
              <ListItemButton
                className={
                  pathname === "/home/history"
                    ? "home_drawer_menu menu-active"
                    : "home_drawer_menu"
                }
                onClick={() => history.push("/home/history")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={historyIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="ປະຫວັດການບໍລິການ"
                />
              </ListItemButton>
            </List>

            <List>
              <ListItemButton
                className={
                  pathname === "/home/qr-code"
                    ? "home_drawer_menu menu-active"
                    : "home_drawer_menu"
                }
                onClick={() => history.push("/home/qr-code")}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <span style={{ paddingBottom: ".2rem" }}>
                    <>
                      <img className='home_menu_icon' src={qrcodeIcon} width='20' />
                    </>
                  </span>
                </ListItemIcon>

                <ListItemText
                  primary="QR-Code"
                />
              </ListItemButton>
            </List>

          </Box>
        </div>
      </Drawer>

      <Main open={open}>
        <DrawerHeader />
        <Typography paragraph>
          <Switch>
            <Route path={"/home"} component={CheckList} exact />
            <Route path={"/home/queue/create"} component={QueueCreate} exact />
            <Route path={"/home/queue/list"} component={QueueList} exact />
            <Route path={"/home/queue/pass"} component={QueuePass} exact />
            <Route path={"/home/service"} component={ServiceList} exact />
            <Route path={"/home/check_date"} component={CheckInHistory} exact />
            <Route path={"/home/history"} component={ServiceHistory} exact />
            <Route path={"/home/qr-code"} component={QRCode} exact />
          </Switch>
        </Typography>
      </Main>
    </Box >
  );
} 